const SESSION_UPDATED = (state, session) => {
  state.session = session
}

export default {
  SESSION_UPDATED,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/session/mutations.js